<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
<!--    <button class="navbar-toggler" type="button" data-toggle="collapse"-->
<!--      data-target="#navbarSupportedContent"-->
<!--      aria-controls="navbarSupportedContent" aria-expanded="false"-->
<!--      aria-label="Toggle navigation">-->
<!--      <span class="navbar-toggler-icon"></span>-->
<!--    </button>-->

<!--    <div class="collapse navbar-collapse" id="navbarSupportedContent">-->
    <span class="mr-auto">
      <button
        mat-raised-button
        color="primary"
        (click)="onAdd()"
        matTooltip="Add a new note to this incident."
        class="m-1 mr-2">
        <mat-icon>add</mat-icon>
        Add Note
      </button>

      <mat-menu #appMenu="matMenu">
        <button mat-menu-item (click)="dataSource.selectAllToggle()">
          <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
          {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
        </button>
        <button mat-menu-item (click)="onDeleteSelected()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>delete</mat-icon> Delete Selected
        </button>
      </mat-menu>

      <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Incident Notes." style="min-width: 120px">
        <mat-icon>more_vert</mat-icon>
        List Menu
      </button>
    </span>

    <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search" />
      <button
        mat-raised-button
        class="mx-0 my-1"
        color="secondary"
        type="submit">
        <mat-icon>search</mat-icon>Search
      </button>
    </form>

<!--    </div>-->
  </nav>

  <table mat-table [dataSource]="dataSource" matSort matSortActive="name"
    matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        #
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Note
      </th>
      <td mat-cell *matCellDef="let element">
        <div style="white-space: normal;">{{ element.value }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_by_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Created By
      </th>
      <td mat-cell *matCellDef="let element">
        <a (click)="onUserPublicView(element.hash)"
           matTooltip="View User Public Profile">
          {{ element.created_by_name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Date Created
      </th>
      <td mat-cell *matCellDef="let element">
        {{ (element.date_created * 1000) | timezoneConvertMedium}}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Date Created (UTC)
      </th>
      <td mat-cell *matCellDef="let element">
        {{ (element.date_created * 1000) | timezoneConvertUTCMedium}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>

      <td mat-cell *matCellDef="let element">
        <button type="button" mat-button (click)="onEdit(element)">
          Edit
        </button>

        <button type="button" mat-button (click)="onRemove(element.id)">
          Delete
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
